import React from "react";

const GoogleMap = ({ extraClass }) => {
  return (
    <div className={`google-map__${extraClass}`}>
      <iframe
        title="template google map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d120636.1246469079!2d72.79900094342625!3d19.112968055345508!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c97629cdd3c5%3A0x35226d4262ca91e!2sJCI%20INDIA%20NATIONAL%20HEAD%20QUARTER!5e0!3m2!1sen!2sin!4v1616677978152!5m2!1sen!2sin"
        className={`map__${extraClass}`}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default GoogleMap;
